module.exports = __webpack_public_path__ + "img/EC.ea705943.svg";